var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['logo', _vm.type],style:({backgroundImage: 'url(' + _vm.logoImage + ')'}),on:{"click":_vm.toHome}})}
var staticRenderFns = []

export { render, staticRenderFns }